import React, { HTMLAttributes, LegacyRef, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, XtLocale, Cookie, Storage } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { LimitProps, WithdrawLimitProps } from "../Company";
import { waitRes } from "@/utils/axios";
// import { get_kycLimit } from "@/api/exchange-otc"; // kyc-limit 接口已注释
import { get_kycWalletLimit } from "@/api/xt4/wallet";
import { get_countryInfos, get_resetKycInfo, getAuthType, getAuthAccess } from "@/api/uaapi/user";
import XtSvg from "@/components/Xt/Svg";
import { Modal, Tooltip, message } from "antd";
import { CountryInfosProps } from "@/store/user";
import CountryDropdown from "@/components/App/CountryDropdown";
import { ListItemProps } from "@/components/Xt/Dropdown";
import { useRouter } from "next/router";
import snsWebSdk from "@sumsub/websdk";
interface KycInfoProps {
  cardId?: string;
  cardType?: number;
  cardTypeName?: string;
  countryId?: string;
  countryName?: string;
  realName?: string;
}
interface PersonalProps extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}
const { useTranslation } = Hooks;
const langMap = {
  "zh-CN": "zh",
  "zh-HK": "zh",
  en: "en",
  ko: "ko",
  ja: "ja",
  hi: "hi",
  id: "id",
  ru: "ru",
  es: "es",
  tr: "tr",
  vi: "vi",
  th: "th",
};

const Personal: React.FC<PersonalProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  const containerRef = useRef<HTMLDivElement>(null);
  const { authLevel, initialAuth, authInfo, isInitialAuth, getAuthInfo } = store.user;
  //const {isLogin} = store.user;
  const [limitList, setLimitList] = useState<LimitProps[]>([]);
  const [withdrawLimitList, setWithdrawLimitList] = useState<WithdrawLimitProps[]>([]);
  const [kycInfo, setKycInfo] = useState({} as KycInfoProps);
  const [isShowAuthModal, setIsShowAuthModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [kycPopConfirm, setKycPopConfirm] = useState(false);
  const [countryId, setCountryId] = useState(0); // 下来选择国家的id
  const [countryAlp, setCountryAlp] = useState("ALB");
  /** useEffect */
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    // 获取国家列表
    await getCountryList();
    getAuthInfo();
    getKycWithdrawLimit();
  };

  useEffect(() => {
    const { advanceAuthStatus } = authInfo.userAuthInfoVo;
    if ([0, 3].includes(advanceAuthStatus)) return setKycPopConfirm(true);
    setKycPopConfirm(false);
  }, [authInfo.userAuthInfoVo]);

  useEffect(() => {
    if (authInfo.country && authInfo.country.id) {
      setCountryId(authInfo.country.id);
      Storage.set("countryId", authInfo.country.id);
    }
  }, [authInfo]);

  /**useMemo */
  const limitText = useMemo(() => {
    const limitItem = limitList.find((ii) => ii.grade == authLevel);
    return authLevel == 0
      ? t("account.NoTrading")
      : limitItem?.limitAmount || limitItem?.limitAmount == 0
      ? limitItem.limitAmount + " USD/" + t("account.periodDay")
      : t("account.NoLimit");
  }, [authLevel, limitList]);
  const encryptLimitext2 = useMemo(() => {
    const limitItem = limitList.find((ii) => ii.grade == 2);
    return limitItem?.limitAmount || limitItem?.limitAmount == 0 ? limitItem.limitAmount + " USD/" + t("account.periodDay") : t("account.NoLimit");
  }, [limitList]);
  const encryptLimitext = useMemo(() => {
    const limitItem = withdrawLimitList.find((ii) => ii.grade == authLevel);
    return limitItem?.limitAmount || limitItem?.limitAmount == 0 ? limitItem.limitAmount + " USD/" + t("account.periodDay") : t("account.NoLimit");
  }, [withdrawLimitList]);
  const withdrawLimitText2 = useMemo(() => {
    const withdrawLimitItem = withdrawLimitList.find((ii) => ii.grade == 2);
    return withdrawLimitItem?.limitAmount || withdrawLimitItem?.limitAmount == 0
      ? withdrawLimitItem.limitAmount + " USDT/" + t("account.periodDay")
      : t("account.NoLimit");
  }, [withdrawLimitList]);
  /** method */

  const getKycWithdrawLimit = async () => {
    const defaultResWallet = [
      { grade: 0, limitAmount: 1000000, id: 1 },
      { grade: 1, limitAmount: 1000000, id: 2 },
      { grade: 2, limitAmount: 1000000, id: 3 },
      { grade: 3, limitAmount: 1000000, id: 4 },
    ];
    // 法币 - kyc-limit 接口已注释，使用默认限额
    // const { data, err } = await waitRes(get_kycLimit, { isResFull: true });
    // !err && setLimitList(data && data.length != 0 ? [...data] : defaultResWallet);
    setLimitList(defaultResWallet);

    // 提现
    const { data: resWallet, err: errWallet } = await waitRes(get_kycWalletLimit, {});
    !errWallet && setWithdrawLimitList(resWallet && resWallet.length != 0 ? resWallet : defaultResWallet);
  };

  const getCountryList = async () => {
    const CookieCountryId = Cookie.get("countryId");
    const { data, err }: { data: CountryInfosProps; err?: string } = await waitRes(get_countryInfos, "", { params: { userBehaviorEnum: "KYC_AUTH" } });
    if (err) return;
    store.user.updateState({ countryList: data?.countryList || [] });
    const newCountryId = !data.ipCountryId ? data.defaultCountryId : CookieCountryId || data.ipCountryId || data.defaultCountryId;
    setCountryId(+newCountryId!);
    Storage.set("countryId", +newCountryId!);
  };

  const handleSelectCountry = (key: string | number, item: ListItemProps) => {
    setCountryId(+key);
    console.log(item, "item");
    Storage.set("countryId", +key);
  };

  const handleGetResetKycInfo = async () => {
    const { data: res, err } = await waitRes(get_resetKycInfo);
    !err && setKycInfo(res);
  };

  const handleShowUserInfo = () => {
    if (authLevel != 0) {
      handleGetResetKycInfo();
      setIsShowAuthModal(true);
    }
  };

  const jumpConfirm = (val?: string | number | null) => {
    // 跳转到老XT认证流程: 初级认证状态 0为未提交，1审核中，2审核通过，3审核不通过 4审核不通过(不可再次提交)
    if (authType == 3) {
      getAccessTokenData();
      // 启动 sumsub
      return;
    }

    if (val === 1) {
      // 实名认证
      router.push("/accounts/user/levels");
    } else {
      router.push("/accounts/user/levels");
    }
  };

  const [accessToken, setAccessToken] = useState("");

  const accessTokenExpirationHandler = () => {
    return getAuthAccess({
      errorPop: true,
      params: {
        countryId,
        type: 3,
      },
    }).then((res) => {
      return res.token;
    });
  };

  const messageHandler = (type, payload) => {
    // idCheck.onApplicantStatusChanged 需要重新认证
    // GREEN 为认证成功
    console.log("WebSDK onMessage", type, payload);
    if (payload.reviewStatus && payload.reviewStatus == "pending") {
      setTimeout(() => {
        setAccessToken("");
        window.location.reload();
      }, 4000);
    }
    if (payload.reviewResult && payload.reviewResult.reviewAnswer == "GREEN") {
      setTimeout(() => {
        setAccessToken("");
        getAuthInfo();
        document.body.style.overflowY = "auto";
      }, 4000);
    }
  };

  const errorHandler = (error) => {
    console.error("WebSDK onError-----------------", error);
  };

  // 根据国家获取认证方式 1: 人工, 3: sumsub
  const [authType, setAuthType] = useState(0);
  const getAuthTypeData = async () => {
    const { err, data } = await waitRes(getAuthType, {
      params: {
        countryId,
      },
    });
    if (err) return;
    if (!data.type) {
      setAuthType(1);
    } else {
      setAuthType(data.type);
    }
  };

  const getAccessTokenData = async () => {
    const { err, data } = await waitRes(getAuthAccess, {
      errorPop: true,
      params: {
        countryId,
        type: 3,
      },
    });
    if (err) return;
    if (data) {
      setCountryAlp(data.countryNameAlph3);
      setAccessToken(data.token);
    }
  };

  useEffect(() => {
    if (countryId) {
      getAuthTypeData();
    }
  }, [countryId]);
  useEffect(() => {
    if (!accessToken) return;
    document.body.style.overflowY = "hidden";
    const sumsub = snsWebSdk
      .init(accessToken, accessTokenExpirationHandler)
      .withConf({
        lang: langMap[router.locale || "en"],
        i18n: {
          document: {
            subTitles: { IDENTITY: "Upload a document that proves your identity" },
          },
        },
        country: countryAlp,
        uiConf: {
          customCssStr:
            ":root {\n  --black: #000000;\n   --grey: #F5F5F5;\n  --grey-darker: #B2B2B2;\n  --border-color: #DBDBDB;\n}\n\np {\n  color: var(--black);\n  font-size: 16px;\n  line-height: 24px;\n}\n\nsection {\n  margin: 40px auto;\n}\n\ninput {\n  color: var(--black);\n  font-weight: 600;\n  outline: none;\n}\n\nsection.content {\n  background-color: var(--grey);\n  color: var(--black);\n  padding: 40px 40px 16px;\n  box-shadow: none;\n  border-radius: 6px;\n}\n\nbutton.submit,\nbutton.back {\n  text-transform: capitalize;\n  border-radius: 6px;\n  height: 48px;\n  padding: 0 30px;\n  font-size: 16px;\n  background-image: none !important;\n  transform: none !important;\n  box-shadow: none !important;\n  transition: all 0.2s linear;\n}\n\nbutton.submit {\n  min-width: 132px;\n  background: none;\n  background-color: var(--black);\n}\n\n.round-icon {\n  background-color: var(--black) !important;\n  background-image: none !important;\n}",
        },
      })
      .withOptions({ addViewportTag: false, adaptIframeHeight: true })
      .on("idCheck.stepCompleted", (payload) => {
        console.log("stepCompleted", payload);
      })
      .on("idCheck.onError", errorHandler)
      .onMessage(messageHandler)
      .build();
    sumsub.launch("#sumsub-websdk-container");
    return () => {
      sumsub.destroy();
    };
  }, [accessToken]);

  return (
    <>
      {limitList && limitList.length ? (
        <div className={cx(styles["v-auth-guide"], className)}>
          <div className={styles["ll-auth-guide-div"]}>
            <div className={styles["flex_top"]}>
              <div className={styles["box-left"]}>
                {/* 等级 */}
                <div className={styles["p_lever"]} onClick={handleShowUserInfo}>
                  {/* <span className={styles["icon_lever"]}> */}
                    {/* <XtSvg src={require("@/assets/icon-svg/account/mingcheng.svg")} width={16} height={16}></XtSvg> */}
                  {/* </span> */}
                  <span className={styles["lever_name"]} style={{ color: authLevel == 0 ? "rgba(238, 86, 87, 1)" : "" }}></span>
                  <span>{authLevel == 0 ? t("account.unverified") : t("account.verified")}</span>
                </div>
                {/* 当前限额 */}
                {/* <div className={cx(styles["view_btn"], styles["view_top"])} ref={containerRef}>
                  <span
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    {t("account.CurrentAmountLimit")}
                  </span>
                </div> */}
              </div>

              <div className={styles["box-right"]}>
                <label>{t("account.countryCode")}</label>
                {[1, 2].includes(+initialAuth) ? (
                  // 语种
                  authInfo.country && (
                    <div className={styles["text-country"]}>
                      <img className="flag" src={authInfo.country.nationalFlagIcon} alt="" />
                      <span>
                        {XtLocale.getZenLan() === "zh-cn"
                          ? `${authInfo.country.name} (${authInfo.country.nameEn})`
                          : authInfo.country.name || authInfo.country.nameEn}
                      </span>
                    </div>
                  )
                ) : (
                  // 下拉国家选择
                  <div className={styles["select-country"]} onClick={() => setKycPopConfirm(false)}>
                    <div className={cx(styles["box-select"], kycPopConfirm && styles["box-index"])}>
                      <CountryDropdown value={countryId} onChange={handleSelectCountry} />
                    </div>
                  </div>
                )}
                {/* 背景 */}
                {kycPopConfirm && <div className="ant-modal-mask"></div>}
                {/* KYC引导确认框 */}
                {kycPopConfirm && (
                  <div className={cx(styles["role_div"], styles["confirm_pop"], "ant-popover-placement-bottom")} data-popover="kyc-confirm">
                    <div className={styles["role_bi_div"]}>
                      <div className={styles["role_tit"]}>{t("account.kycConfirm")}</div>
                      <div className={styles["role_btn"]} onClick={() => setKycPopConfirm(false)}>
                        {t("account.Confirm")}
                      </div>
                    </div>
                    <div className={"ant-popover-arrow"}>
                      <span className={"ant-popover-arrow-content"}></span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles["confirm_content"]}>
            <div className={styles["confirm_list"]}>
              <div className={styles["list_content"]}>
                <div className={styles["list_c_header"]}>
                  <span>{t("account.Authentication")}</span>
                  <div>
                    {isInitialAuth && <span className={styles["is_confirm"]}>{t("account.verified")}</span>}
                    {!isInitialAuth && initialAuth == 1 && (
                      <span className={styles["is_confirm"]} style={{ color: "rgba(56, 55, 66, 1)", backgroundColor: "rgba(243, 245, 247, 1)" }}>
                        {t("account.UnderReview")}
                      </span>
                    )}
                    {!isInitialAuth && (initialAuth == 3 || initialAuth == 4) && (
                      <span className={styles["is_confirm"]} style={{ color: "rgba(238, 86, 87, 1)", backgroundColor: "rgba(238, 86, 87, 0.1)" }}>
                        {t("account.Failed")}
                      </span>
                    )}
                  </div>
                </div>
                <div className={styles["list_container"]}>
                  <div className={styles["c_list"]}>
                    <XtSvg src={require("@/assets/icon-svg/account/photo.svg")} size={16}></XtSvg>
                    <span className={styles["c_font"]}>{t("account.PhotoVerificationNew")}</span>
                  </div>
                  <div className={styles["c_list"]}>
                    <XtSvg src={require("@/assets/icon-svg/account/rights.svg")} size={16}></XtSvg>
                    <span className={styles["c_font"]}>{t("account.AddFiatTradingPermissionNew")}</span>
                  </div>
                  <div className={styles["c_list"]}>
                    <XtSvg src={require("@/assets/icon-svg/account/time.svg")} size={16}></XtSvg>
                    <span className={styles["c_font"]}>{t("account.ReviewPeriodWithin2Days")}</span>
                  </div>
                </div>
                <div className={styles["fenge"]}>
                  {initialAuth == 1 || initialAuth == 2 ? (
                    <div className={styles["dasheds"]}></div>
                  ) : initialAuth == 3 || initialAuth == 4 ? (
                    <div className={styles["again_confirm"]}>
                      <div className={styles["a_icon"]}>
                        <XtSvg src={require("@/assets/icon-svg/account/unpass.svg")} size={16} style={{ color: "rgba(185, 185, 186, 1)" }}></XtSvg>
                        <Tooltip placement="topRight" title={authInfo.userAuthInfoVo.failReason}>
                          <span>
                            {t("account.Whyreviewfailed")}: {authInfo.userAuthInfoVo.failReason}
                          </span>
                        </Tooltip>
                      </div>
                      {initialAuth == 3 && (
                        <div
                          className={styles["again_to"]}
                          onClick={() => {
                            jumpConfirm(1);
                          }}
                        >
                          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{t("account.Reverify")}</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      className={styles["toconfirm"]}
                      onClick={() => {
                        jumpConfirm(null);
                      }}
                    >
                      <span>{t("account.VerifyNow")}</span>
                    </div>
                  )}
                </div>

                <div className={styles["list_footer"]}>
                  <div className={styles["bicontent"]}>
                    <div className={styles["bi_list"]}>
                      <p className={styles[!isInitialAuth ? "isicon" : ""]}>
                        {isInitialAuth && <XtSvg width={16} height={16} src={require("@/assets/icon-svg/account/otc_attestation_success_ico.svg")} />}
                        <span className={styles["bi_name"]}>{t("account.Fiat")}</span>
                      </p>
                      <div className={styles["bi_mes"]}>
                        <div className={styles["cz"]}>
                          <span>{t("account.deposit")}:</span>
                          <span className={styles["no_limit"]}>{t("account.NoLimit")}</span>
                        </div>
                        <div className={styles["tixian"]}>
                          <span>{t("account.withdraw")}:</span>
                          <span className={styles["no_limit"]}>{encryptLimitext2}</span>
                        </div>
                      </div>
                    </div>
                    <div className={cx(styles["bi_list"], styles["mr2s"])}>
                      <p className={styles[!isInitialAuth ? "isicon" : ""]}>
                        {isInitialAuth && <XtSvg width={16} height={16} src={require("@/assets/icon-svg/account/otc_attestation_success_ico.svg")} />}
                        <span className={styles["bi_name"]}>{t("account.Cryptocurrency")}</span>
                      </p>
                      <div className={styles["bi_mes"]}>
                        <div className={styles["cz"]}>
                          <span>{t("account.deposit")}:</span>
                          <span className={styles["no_limit"]}>{t("account.NoLimit")}</span>
                        </div>
                        <div className={styles["tixian"]}>
                          <span>{t("account.withdraw")}:</span>
                          <span className={styles["no_limit"]}>{withdrawLimitText2}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 认证信息弹框 */}
          <Modal
            className={styles["auth-modal"]}
            open={isShowAuthModal}
            title={t("account.userInfo")}
            onCancel={() => setIsShowAuthModal(false)}
            footer={null}
          >
            <p style={{ marginBottom: "1em" }}>{t("account.userInfoTips")}</p>
            <div className={styles["auth-modal-item"]}>
              <span>{t("account.countryCode")}</span>
              <span>{kycInfo.countryName}</span>
            </div>
            <div className={styles["auth-modal-item"]}>
              <span>{t("account.userCard")}</span>
              <span>
                {kycInfo.cardType == 1
                  ? t("account.idCard")
                  : kycInfo.cardType == 2
                  ? t("account.passport")
                  : kycInfo.cardType == 3
                  ? t("account.driverCard")
                  : t("account.others")}
              </span>
            </div>
            <div className={styles["auth-modal-item"]}>
              <span>{t("account.userCardNumber")}</span>
              <span>{kycInfo.cardId}</span>
            </div>
            <div className={styles["auth-modal-item"]}>
              <span>{t("newAccount.userName")}</span>
              <span>{kycInfo.realName}</span>
            </div>
          </Modal>
          {/* 当前限额弹框 */}
          <Modal
            className={styles["auth-modal"]}
            open={showModal}
            title={t("account.checkAuth")}
            onCancel={() => {
              setShowModal(false);
            }}
            footer={null}
          >
            <p>{t("account.remainingAmount")}</p>
            {/* 法币交易 */}
            <div className={styles["role_bi_div"]}>
              <div className={styles["role_tit"]}>{t("account.Fiats")}</div>
              <div className={styles["role_con"]}>
                <div>{t("account.deposit")}：</div>
                <div className={authLevel == 0 ? styles["role_con_noTrading"] : ""}>{authLevel == 0 ? t("account.NoTrading") : t("account.NoLimit")}</div>
              </div>
              <div className={styles["role_con"]}>
                <div>{t("account.withdraw")}：</div>
                <div className={authLevel == 0 ? styles["role_con_noTrading"] : ""}>{limitText}</div>
              </div>
            </div>

            {/* 加密货币 */}
            <div className={styles["role_bi_div"]}>
              <div className={styles["role_tit"]}>{t("account.Cryptocurrency")}</div>
              <div className={styles["role_con"]}>
                <div>{t("account.deposit")}</div>
                <div>{t("account.NoLimit")}</div>
              </div>
              <div className={styles["role_con"]}>
                <div>{t("account.withdraw")}</div>
                <div>{encryptLimitext}</div>
              </div>
            </div>
          </Modal>
        </div>
      ) : null}

      {accessToken && <div className={styles.sumsubContainer} id="sumsub-websdk-container"></div>}
    </>
  );
};
export default observer(Personal);
